import React, { useContext } from 'react';
import { Button } from 'primereact/button';
import { useHistory } from 'react-router-dom';
import { AccountContext } from '../../../../components/AccountContext';
import useSubscriptionExpiredRestrictions from '../../../../hooks/useSubscriptionExpiredRestrictions';
import { defineMessages, useIntl } from 'react-intl';

const i18nMessages = defineMessages({
  addButton: {
    id: 'account.super-profiles.add-button',
    defaultMessage: 'Add SuperProfile',
  },
});

const AddSuperProfileButton = () => {
  const currentAccount = useContext(AccountContext);
  const history = useHistory();
  const { formatMessage } = useIntl();
  const { subscriptionIsExpired } = useSubscriptionExpiredRestrictions();

  return (
    <Button
      label={formatMessage(i18nMessages.addButton)}
      icon="fa fa-plus"
      disabled={subscriptionIsExpired}
      onClick={() => history.push(`/accounts/${currentAccount}/super-profiles/new`)}
    />
  );
};

export default AddSuperProfileButton;
